import "./css/InfoClient.css";

export default function InfoClient({client}) {
  	return (
        <>
            <div className="card card-action mb-4">
                <div className="card-header align-items-center flex-wrap gap-2">
                    <h5 className="card-action-title mb-0">Informazioni</h5>
                    <div className="card-action-element">
                        <button className="btn btn-primary btn-sm edit-address" type="button">
                            <i className="bx bx-plus bx-xs me-1_5"></i>Modifica
                        </button>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-xl-7 col-12">
                            <dl className="row mb-0 gx-2">
                                <dt className="col-sm-4 mb-sm-2 text-nowrap fw-medium text-heading">PIVA:</dt>
                                <dd className="col-sm-8">{client.piva ? client.piva : 'Non inserita'}</dd>
                                <dt className="col-sm-4 mb-sm-2 text-nowrap fw-medium text-heading">SDI:</dt>
                                <dd className="col-sm-8">{client.identificativo ? client.identificativo : 'Non inserito'}</dd>
                                <dt className="col-sm-4 mb-sm-2 text-nowrap fw-medium text-heading">PEC:</dt>
                                <dd className="col-sm-8">{client.email_pec ? client.email_pec : 'Non inserita'}</dd>
                            </dl>
                        </div>
                        <div className="col-xl-5 col-12">
                            <dl className="row mb-0 gx-2">
                                <dt className="col-sm-4 mb-sm-2 text-nowrap fw-medium text-heading">Telefono:</dt>
                                <dd className="col-sm-8">{client.phone ? client.phone : 'Non inserito'}</dd>
                                <dt className="col-sm-4 mb-sm-2 text-nowrap fw-medium text-heading">Email:</dt>
                                <dd className="col-sm-8">{client.email ? client.email : 'Non inserita'}</dd>
                                <dt className="col-sm-4 mb-sm-2 text-nowrap fw-medium text-heading">Consegna:</dt>
                                <dd className="col-sm-8">{client.indirizzo_consegna ? client.indirizzo_consegna : 'Non inserito'}</dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card card-action mb-6">
                <div className="card-header align-items-center">
                    <h5 className="card-action-title mb-0">Note</h5>
                    {!client.note && (
                    <div className="card-action-element">
                        <button className="btn btn-primary btn-sm edit-address" type="button">
                            <i className="bx bx-plus bx-xs me-1_5"></i>Aggiungi
                        </button>
                    </div>
                    )}
                </div>
                <div className="card-body">
                    <div className="added-cards">
                    {client.note && (
                        <div className="cardMaster border p-6 rounded mb-4">
                            <div className="d-flex justify-content-between flex-sm-row flex-column">
                                <div className="card-information">
                                    <div className="d-flex align-items-center mb-2">
                                        <h6 className="mb-0 me-2">{client.note}</h6>
                                    </div>
                                </div>
                                <div className="d-flex flex-column text-start text-lg-end">
                                    <div className="d-flex order-sm-0 order-1">
                                        <button className="btn btn-sm btn-label-primary me-4">Modifica</button>
                                        <button className="btn btn-sm btn-label-danger">Cancella</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {!client.note && (
                        <h6 className="card-action-title mb-0">Non inserita</h6>
                    )}
                    </div>
                </div>
            </div>
        </>
	);
}